import _ from 'lodash'

export const reduceData = (inputArr) =>
    _.reduce(
        inputArr,
        (acc, obj) => {
            const text = _.get(obj, 'year', '').toString()
            const amount = _.isObject(_.get(obj, 'value', null))
                ? _.get(obj, 'value.amount', null)
                : _.get(obj, 'value', null)
            const category = _.get(obj, 'category', null)
            const categoryLow = _.isNil(_.get(obj, 'category.low')) ? 0 : obj.category.low
            const categoryHigh = _.isNil(_.get(obj, 'category.high')) ? 0 : obj.category.high
            const isDefined = !_.isNil(amount) || !_.isNil(category)
            let lowerLimit = 0
            let upperLimit = 0

            if (!isDefined) return [...acc, { text, isDefined, upperLimit, lowerLimit }]

            if (amount < 0) lowerLimit = amount
            else upperLimit = amount

            return [
                ...acc,
                {
                    text,
                    upperLimit: !_.isNil(amount) ? upperLimit : categoryHigh,
                    lowerLimit: !_.isNil(amount) ? lowerLimit : categoryLow,
                    value: _.get(obj, 'value'),
                    category,
                    isDefined,
                },
            ]
        },
        []
    )

export const transformSizeData = (turnover, profit, employees) => ({
    turnover: reduceData(turnover),
    profit: reduceData(profit),
    employee: reduceData(employees),
})

export const isDataNotEmpty = (data) => _.some(data, (x) => !_.isNil(x?.value) || !_.isNil(x?.category))

export const isProfitNotEmpty = (data) => _.some(data, (x) => !_.isNil(x?.value))

export const isCapitalNotEmpty = (data) => _.some(data, (x) => !_.isNil(x?.equity) || !_.isNil(x?.registered))
